import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";
// import top5RetailersData from '../data/top5.json';
import { isEmptyObject, getJCJPIDs } from "../../../utils/common/index";
import OthersTop5RetailersView from "../../../views/rechargeSales/others/othersTop5RetailersView";

const OthersTop5Retailers = (props) => {
  const dispatch = useDispatch();

  const { headerUnit } = useSelector((state) => state.homeReducer);

  const { getTopFiveRetailer } = useSelector(
    (state) => state.rechargeSalesReducer
  );

  let {
    url,
    filterValue,
    headerSelectedDateFrom,
    headerSelectedDateTo,
    triggerFetchTopRetailers,
  } = props;

  let { level, jioPointId, partnerRT, retailerId } = getJCJPIDs(filterValue);

  const headers = {
    id: filterValue.orgId
      ? filterValue.orgId
      : filterValue.selectedRole.split(" - ")[2],
    partnerRoleType: partnerRT,
    fromDate: headerSelectedDateFrom,
    toDate: headerSelectedDateTo,
    dispValue: headerUnit.unit,
    jprTypeName: "",
    section: props.section,
    moduleName: props.moduleName,
    isRedisActive: "YES",
    jioPointId,
    retailerId,
    level,
  };

  useEffect(() => {
    function fetchTop5RetailersData() {
      const obj = {
        headers: {
          "Content-Type": "application/json",
          url: url,
        },
        params: headers,
        extraData: url,
      };
      return dispatch(triggerFetchTopRetailers(obj));
    }
    if (
      getTopFiveRetailer &&
      isEmptyObject(getTopFiveRetailer.data) &&
      partnerRT !== "DT"
    ) {
      fetchTop5RetailersData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    triggerFetchTopRetailers,
    headerSelectedDateFrom,
    headerSelectedDateTo,
    headerUnit,
  ]);

  return <OthersTop5RetailersView partnerRT={partnerRT} />;
};

OthersTop5Retailers.propTypes = {
  url: PropTypes.string,
  content: PropTypes.object,
};

export default OthersTop5Retailers;
